<div class="spinner">
  <mat-spinner [strokeWidth]="strokeWidth" [diameter]="diameter"></mat-spinner>
</div>